import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { DashboardComponent } from './funciones/dashboard/dashboard.component';
import { authGuard } from './core/guards/auth.guard';
import { InfoComponent } from './funciones/info/info.component';
import { PoliciesComponent } from './funciones/policies/policies.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./funciones/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'info',
    component: InfoComponent,
  },
  {
    path: 'laboratorio',
    loadChildren: () =>
      import('./funciones/laboratorio/laboratorio.module').then(
        (m) => m.LaboratorioModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'selector-sistema',
    loadChildren: () =>
      import('./funciones/selector-sistema/selector-sistema.module').then(
        (m) => m.SelectorSistemaModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./funciones/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'recorredores',
    loadChildren: () =>
      import('./funciones/recorredores/recorredores.module').then(
        (m) => m.RecorredoresModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./funciones/admin-blister/admin-blister.module').then(
        (m) => m.AdminBlisterModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'almacenes',
    loadChildren: () =>
      import('./funciones/almacenes/almacenes.module').then(
        (m) => m.AlmacenesModule,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'policies',
    component: PoliciesComponent,
    title: 'Política de Privacidad | Chevron IPCMS',
  },
  // {
  //   path: '**',
  //   redirectTo: 'login',
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
